import React, { useEffect, useRef, useState } from 'react';
import { getConfiguration } from '../data/utils/configuration';
import { REGEX_URL } from '../data/utils';
import { systemCode, xs_languageCode } from '..';
import { openPopup } from '../data/sport-utils';
import { getBaseURL } from '../data/utils/getBaseURL';
import { getCheckbetPage } from '../data/utils/getCheckbetPage';
import { labels } from '../data/labels';
import { CheckTicketContext } from './CheckTicketPopup';



function CheckTicket(props) {
    const conf = getConfiguration()
    const checkTicketContext = React.useContext(CheckTicketContext);
    const inputRef = useRef();
    const [showScannerType,setShowScannerType] = useState(false);

    function handleClickScan(scan){
      if(conf.mst=='ALL'){
        setShowScannerType(true);
      }else if (conf.mst=='BARCODE'){
        startBarCodeScanner(scan)
      }else if(conf.mst=='QRCODE'){
        startQrCodeScanner(scan)
      }else{
        startQrCodeScanner(scan)
      }
    }

    function startBarCodeScanner(scanning){
      checkTicketContext.setScannerStarted(scanning,'BARCODE');
    }
    function startQrCodeScanner(scanning){
      checkTicketContext.setScannerStarted(scanning,'QRCODE');
    }

    function openCheckbet(){
      if(checkTicketContext.ticketId || inputRef.current.value != '') {
        const ticketId = inputRef.current.value || checkTicketContext.ticketId;
        let url;
        if(REGEX_URL.test(ticketId)){
          url = ticketId;
        }else{
          const baseURL = getBaseURL();
          const checkbetPage = getCheckbetPage(true);
          url = `${baseURL.replace('xsport_desktop', 'xsport_mobile')}${checkbetPage}?ticket=${ticketId}&system_code=${systemCode}&language=${xs_languageCode}`;
        }
       
    	  // always in mobile version, 'cause it is full resposive
        openPopup( url,labels['general.checkbet'], 400, 800);
      }
    }

    useEffect(() => {
      if(checkTicketContext.ticketId){
        inputRef.current.value = checkTicketContext.ticketId;
      }
    }, [checkTicketContext.ticketId]);

    useEffect(() => {
      if(props.openTicketScanner){
        handleClickScan(true);
      }
    }, []);

    return (
        <>
        {showScannerType?
          <div className="checkTicket__container">
            <div className="checkTicket__buttonsContainer">
              <div className="checkTicket__button checkTicket__button--scan" onClick={startBarCodeScanner} >
                  <i className="checkTicket__buttonIcon fa fa-barcode"aria-hidden="true"></i>
                  <label>{labels['check_ticket.scan.barcode'] || 'Barcode'}</label>
              </div>
              <div className="checkTicket__button checkTicket__button--scan" onClick={startQrCodeScanner} >
                  <i className="checkTicket__buttonIcon fa fa-qrcode"aria-hidden="true"></i>
                  <label>{labels['check_ticket.scan.qrcode'] || 'QR Code'}</label>
              </div>
            </div>
          </div>
          :
          (!props.openTicketScanner && 
            <div className="checkTicket__container">
              <div className="checkTicket__id">
                <label>ID:&nbsp;</label>
                <div className="checkTicket__id__inputContainer">
                  <input
                    ref={inputRef}
                    className="checkTicket__id__input"
                    autoComplete="off"
                    type="text"
                    id="check-ticket-id"
                  />
                </div>
              </div>

              <div className="checkTicket__buttonsContainer">
                <div className="checkTicket__button checkTicket__button--scan" onClick={handleClickScan } >
                  <img
                    className="checkTicket__buttonIcon"
                    src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiA/PjxzdmcgZmlsbD0ibm9uZSIgaGVpZ2h0PSIyNCIgc3Ryb2tlPSIjMDAwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMiIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIzIDE5YTIgMiAwIDAgMS0yIDJIM2EyIDIgMCAwIDEtMi0yVjhhMiAyIDAgMCAxIDItMmg0bDItM2g2bDIgM2g0YTIgMiAwIDAgMSAyIDJ6Ii8+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMyIgcj0iNCIvPjwvc3ZnPg=="
                  /><label>{labels['check_ticket.scan']}</label>
                </div>
                <div className="checkTicket__button checkTicket__button--verifica" onClick={openCheckbet} >
                  <label>{labels['check_ticket.check']}</label>
                </div>
              </div>
          </div>
          )
          
        }
        </>
         
    )
}

export default CheckTicket;